import { render, staticRenderFns } from "./tkb.vue?vue&type=template&id=2b56eb6e&scoped=true&"
import script from "./tkb.vue?vue&type=script&lang=js&"
export * from "./tkb.vue?vue&type=script&lang=js&"
import style0 from "./tkb.vue?vue&type=style&index=0&id=2b56eb6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b56eb6e",
  null
  
)

export default component.exports